import { render } from "./NewFrame.vue?vue&type=template&id=59b77680&scoped=true"
import script from "./NewFrame.vue?vue&type=script&lang=js"
export * from "./NewFrame.vue?vue&type=script&lang=js"

import "./NewFrame.vue?vue&type=style&index=0&id=59b77680&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b77680"]])

export default __exports__